import React, { useEffect, useState, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import Styles from "../BuySell/BuySell.module.css";
import { useLocation } from "react-router-dom";
import {
  fetchActiveLedger,
  fetchArchiveConnectionList,
  fetchArchiveList,
  fetchArchiveWithdrawanList,
  fetchBankingArchive,
  fetchMatchmakingResults,
} from "../../../Redux/Slices/bankingSlice";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
} from "../../../commons/Accordion";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ActiveListingConnection from "../../Modals/Banking/BankingReceivedTabs/ActiveListingConnection/ActiveListingConnection";
import { ReactComponent as SquareIcon } from "../../../assets/images/squareIcon.svg";
import ViewInjectionModal from "../../Modals/Banking/ViewInjectionModal/ViewInjectionModal";
import ViewDrawalModal from "../../Modals/Banking/ViewDrawalModal/ViewDrawalModal";
import { openBilateralChat } from "../../Modals/Banking/CreateEdit/helpers";
import ArchiveModal from "../../Modals/Banking/ArchiveModal/ArchiveModal";
import ViewInjectDrawal from "../../Modals/Banking/ViewInjectDrawal/ViewInjectDrawal";
import { BorderBottom, BorderTopOutlined } from "@mui/icons-material";
import LoadMorePagination from "../../LoadeMore";

const LoaderNoData = ({ loading, dataLength }) => {
  if (loading) {
    return (
      <div className={Styles.loaderContainer}>
        <div className={Styles.loader} role="status" aria-label="loading" />
      </div>
    );
  }
  if (!loading && dataLength === 0) {
    return <div className={Styles.noDataContainer}>No records found</div>;
  }
  return null;
};

const SummaryHeader = () => (
  <div className={Styles.accordionSummaryContainer}>
    <table
      className={Styles.summaryTable}
      style={{ tableLayout: "fixed", width: "100%" }}
    >
      <colgroup>
        <col style={{ width: "5%" }} />
        <col style={{ width: "15%" }} />
        <col style={{ width: "19%" }} />
        {/* <col style={{ width: "22%" }} /> */}
        <col style={{ width: "10%" }} />
        <col style={{ width: "10%" }} />
        {/* <col style={{ width: "12%" }} /> */}
      </colgroup>
      <thead className={Styles.summaryHeader}>
        <tr>
          <th className={Styles.summaryHeaderCell}>S.No</th>
          <th className={Styles.summaryHeaderCell}>Listing Id</th>
          <th className={Styles.summaryHeaderCell}>Injection/Drawal Range</th>
          {/* <th className={Styles.summaryHeaderCell}>Drawal Range</th> */}
          <th className={Styles.summaryHeaderCell}>Banking Factor(%)</th>
          <th className={Styles.summaryHeaderCell}>Settlement Rate(₹/kWh)</th>
          {/* <th className={Styles.summaryHeaderCell}>Status</th> */}
        </tr>
      </thead>
    </table>
  </div>
);

const SummaryHeaderWithdrawn = () => (
  <div className={Styles.accordionSummaryContainer}>
    <table
      className={`scroll_bar_y ${Styles.summaryTable}`}
      style={{ tableLayout: "fixed", width: "100%" }}
    >
      <colgroup>
        <col style={{ width: "5%" }} />
        <col style={{ width: "15%" }} />
        {/* <col style={{ width: "19%" }} /> */}
        <col style={{ width: "22%" }} />
        <col style={{ width: "10%" }} />
        <col style={{ width: "10%" }} />
        {/* <col style={{ width: "12%" }} /> */}
      </colgroup>
      <thead className={Styles.summaryHeader}>
        <tr>
          <th className={Styles.summaryHeaderCell}>S.No</th>
          <th className={Styles.summaryHeaderCell}>Listing Id</th>
          <th className={Styles.summaryHeaderCell}>Injection/Drawal Range</th>
          {/* <th className={Styles.summaryHeaderCell}>Drawal Range</th> */}
          <th className={Styles.summaryHeaderCell}>Banking Factor(%)</th>
          <th className={Styles.summaryHeaderCell}>Settlement Rate(₹/kWh)</th>
          {/* <th className={Styles.summaryHeaderCell}>Expired On</th> */}
        </tr>
      </thead>
    </table>
  </div>
);

const SummaryHeaderExpired = () => (
  <div className={Styles.accordionSummaryContainer}>
    <table
      className={`scroll_bar_y ${Styles.summaryTable}`}
      style={{ tableLayout: "fixed", width: "100%" }}
    >
      <colgroup>
        <col style={{ width: "5%" }} />
        <col style={{ width: "15%" }} />
        <col style={{ width: "19%" }} />
        {/* <col style={{ width: "22%" }} /> */}
        <col style={{ width: "10%" }} />
        <col style={{ width: "10%" }} />
        <col style={{ width: "12%" }} />
      </colgroup>
      <thead className={Styles.summaryHeader}>
        <tr>
          <th className={Styles.summaryHeaderCell}>S.No</th>
          <th className={Styles.summaryHeaderCell}>Listing Id</th>
          <th className={Styles.summaryHeaderCell}>Injection/Drawal Range</th>
          {/* <th className={Styles.summaryHeaderCell}>Drawal Range</th> */}
          <th className={Styles.summaryHeaderCell}>Banking Factor(%)</th>
          <th className={Styles.summaryHeaderCell}>Settlement Rate(₹/kWh)</th>
          <th className={Styles.summaryHeaderCell}>Expired On</th>
        </tr>
      </thead>
    </table>
  </div>
);

const SummaryRow = ({ ele, index, expanded, onToggle }) => {
  const dispatch = useDispatch();
  const [viewInjectionModalOpen, setViewInjectionModalOpen] = useState(false);
  const [selectedInjectionData, setSelectedInjectionData] = useState([]);
  const [viewDrawalModalOpen, setViewDrawalModalOpen] = useState(false);
  const [selectedDrawalData, setSelectedDrawalData] = useState([]);
  const [viewDetails, setViewDetails] = useState(false);
  const [selectedListing, setSelectedListing] = useState(null);
  const [localConnections, setLocalConnections] = useState([]);
  const [isLoadingConnections, setIsLoadingConnections] = useState(false);

  const { archiveConnections = [], loading: matchmakingLoading = false } =
    useSelector((state) => state.bankingSlice || {});

  if (!ele) return null;

  const inject = ele?.bankingSlotInjects?.[0];
  const drawal = ele?.bankingSlotDrawls?.[0];

  // Use local connections state instead of global archiveConnections
  const ledgerPage = Array.isArray(localConnections) ? localConnections : [];

  const connectionData =
    ledgerPage.length > 0
      ? ledgerPage.map((connection) => ({
          selfListing: connection.bankingListing || ele,
          counterPartyListings: [
            {
              ...connection.againstBankingListing,
              connectionId: connection.id,
              status: connection.status,
              agreementStatus: connection.agreementStatus,
              connectionInitiatorListingId: connection.bankingListing?.id,
              finalizedConnectionValues: connection.finalizedConnectionValues,
              ledgers: connection.ledgers || [],
              loaDocumentHistory: connection.loaDocumentHistory || [],
              loiDocumentHistory: connection.loiDocumentHistory || [],
              agreementDocumentHistory:
                connection.agreementDocumentHistory || [],
            },
          ],
        }))
      : [
          {
            selfListing: ele,
            counterPartyListings: [],
          },
        ];

  const handleAccordionChange = async () => {
    onToggle(index);

    if (expanded !== index) {
      setIsLoadingConnections(true);
      try {
        const result = await dispatch(
          fetchArchiveConnectionList({
            listingId: ele?.id,
            status: "DELIVERED",
            page: 0,
            size: 20,
          }),
        ).unwrap();

        // Store connections locally for this specific listing
        setLocalConnections(result?.content || []);
      } catch (error) {
        console.error("Error fetching connections:", error);
        setLocalConnections([]);
      } finally {
        setIsLoadingConnections(false);
      }
    } else {
      // Clear local connections when closing accordion
      setLocalConnections([]);
    }
  };

  const handleViewInjection = (slotData) => {
    if (!slotData || slotData.length === 0) return;
    setSelectedInjectionData(slotData);
    setViewInjectionModalOpen(true);
  };

  const handleViewDrawal = (slotData) => {
    if (!slotData || slotData.length === 0) return;
    setSelectedDrawalData(slotData);
    setViewDrawalModalOpen(true);
  };

  const handleCloseView = () => {
    setViewDetails(false);
    setSelectedListing(null);
  };

  const handleOpenView = (listing) => {
    setSelectedListing(listing);
    setViewDetails(true);
  };

  return (
    <div className={expanded === index ? "" : Styles.detailsMainDrop_inactive}>
      <Accordion
        style={{
          backgroundColor: "#f3f5f8",
          marginTop: index === 0 ? "0px" : "3px",
          border:
            expanded === index ? "1px solid var(--primary-color-text)" : "none",
          borderRadius: "10px",
        }}
        expanded={expanded === index}
        onChange={handleAccordionChange}
      >
        <AccordionSummary
          style={{
            backgroundColor: "white",
            borderRadius: "8px",
            borderBottom: "var(--border-level2)",
          }}
        >
          <div className={Styles.accordionSummaryContainer}>
            <table
              className={Styles.summaryTable}
              style={{ tableLayout: "fixed", width: "100%" }}
            >
              <colgroup>
                <col style={{ width: "5%" }} />
                <col style={{ width: "15%" }} />
                <col style={{ width: "19%" }} />
                <col style={{ width: "10%" }} />
                <col style={{ width: "10%" }} />
                {/* <col style={{ width: "12%" }} /> */}
              </colgroup>
              <tbody>
                <tr>
                  <td className={Styles.summaryCell}>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        gap: 6,
                      }}
                    >
                      <ExpandMoreIcon
                        style={{ fontSize: "18px" }}
                        className={`${Styles.expandIconLeft} ${
                          expanded === index ? Styles.rotateIcon : ""
                        }`}
                      />
                      {index + 1}
                    </div>
                  </td>
                  <td className={Styles.summaryCell}>{ele?.name || "-"}</td>
                  <td
                    className={Styles.summaryViewCell}
                    onClick={(e) => {
                      e.stopPropagation();
                      handleOpenView(ele);
                    }}
                  >
                    View All
                  </td>
                  <td className={Styles.summaryCell}>
                    {ele?.bankingFactor
                      ? Number(ele.bankingFactor).toFixed(2)
                      : "—"}
                  </td>
                  <td className={Styles.summaryCell}>
                    {ele?.settlementRate || "—"}
                  </td>
                  {/* <td className={Styles.summaryCell}>{ele?.expiryAt || "—"}</td> */}
                </tr>
              </tbody>
            </table>
          </div>
        </AccordionSummary>

        <AccordionDetails style={{ backgroundColor: "white" }}>
          {expanded === index && (
            <ArchiveModal
              data={connectionData}
              isLoading={isLoadingConnections || matchmakingLoading}
              onRefresh={() => {}}
              onOngoingStatusDetected={() => {}}
              isInClosedView={true}
            />
          )}
        </AccordionDetails>
      </Accordion>

      {viewInjectionModalOpen && (
        <ViewInjectionModal
          open={viewInjectionModalOpen}
          handleClose={() => setViewInjectionModalOpen(false)}
          data={selectedInjectionData}
        />
      )}

      {viewDrawalModalOpen && (
        <ViewDrawalModal
          open={viewDrawalModalOpen}
          handleClose={() => setViewDrawalModalOpen(false)}
          data={selectedDrawalData}
        />
      )}

      {viewDetails && (
        <ViewInjectDrawal
          open={viewDetails}
          handleClose={handleCloseView}
          data={selectedListing}
        />
      )}
    </div>
  );
};

const SummaryRowWithdrawn = ({ ele, index, expanded, onToggle }) => {
  const dispatch = useDispatch();
  const [viewInjectionModalOpen, setViewInjectionModalOpen] = useState(false);
  const [selectedInjectionData, setSelectedInjectionData] = useState([]);
  const [viewDrawalModalOpen, setViewDrawalModalOpen] = useState(false);
  const [selectedDrawalData, setSelectedDrawalData] = useState([]);
  const [viewDetails, setViewDetails] = useState(false);
  const [selectedListing, setSelectedListing] = useState(null);
  const [localConnections, setLocalConnections] = useState([]);
  const [isLoadingConnections, setIsLoadingConnections] = useState(false);

  const { archiveWithdrawnListConnection, loading: matchmakingLoading } =
    useSelector((state) => state.bankingSlice || {});

  if (!ele) return null;

  const inject = ele?.bankingSlotInjects?.[0];
  const drawal = ele?.bankingSlotDrawls?.[0];

  const ledgerPage = Array.isArray(archiveWithdrawnListConnection)
    ? archiveWithdrawnListConnection
    : [];

  const connectionData =
    ledgerPage.length > 0
      ? ledgerPage.map((item) => ({
          selfListing: item.bankingListing,
          counterPartyListings: item.againstBankingListing
            ? [
                {
                  ...item.againstBankingListing,
                  connectionId: item.id,
                  status: item.status,
                  agreementStatus: item.agreementStatus,
                  ledgers: item.ledgers || [],
                  loaDocumentHistory: item.loaDocumentHistory || [],
                  loiDocumentHistory: item.loiDocumentHistory || [],
                  agreementDocumentHistory: item.agreementDocumentHistory || [],
                },
              ]
            : [],
        }))
      : [
          {
            selfListing: ele,
            counterPartyListings: [],
          },
        ];

  const handleAccordionChange = async () => {
    onToggle(index);

    if (expanded !== index) {
      setIsLoadingConnections(true);
      try {
        const result = await dispatch(
          fetchArchiveWithdrawanList({
            currentPage: 0,
            size: 20,
            listingId: ele?.id,
          }),
        ).unwrap();

        // Store connections locally for this specific listing
        setLocalConnections(result?.content || []);
      } catch (error) {
        console.error("Error fetching connections:", error);
        setLocalConnections([]);
      } finally {
        setIsLoadingConnections(false);
      }
    } else {
      // Clear local connections when closing accordion
      setLocalConnections([]);
    }
  };

  const handleViewInjection = (slotData) => {
    if (!slotData || slotData.length === 0) return;
    setSelectedInjectionData(slotData);
    setViewInjectionModalOpen(true);
  };

  const handleViewDrawal = (slotData) => {
    if (!slotData || slotData.length === 0) return;
    setSelectedDrawalData(slotData);
    setViewDrawalModalOpen(true);
  };

  const handleCloseView = () => {
    setViewDetails(false);
    setSelectedListing(null);
  };

  const handleOpenView = (listing) => {
    setSelectedListing(listing);
    setViewDetails(true);
  };

  return (
    <>
      <div
        className={expanded === index ? "" : Styles.detailsMainDrop_inactive}
      >
        <Accordion
          expanded={expanded === index}
          onChange={handleAccordionChange}
          style={{
            backgroundColor: "#f3f5f8",
            marginTop: index === 0 ? "0px" : "3px",
            border:
              expanded === index
                ? "1px solid var(--primary-color-text)"
                : "none",
            borderRadius: "10px",
          }}
        >
          <AccordionSummary
            style={{
              backgroundColor: "white",
              borderRadius: "8px",
            }}
          >
            <div className={Styles.accordionSummaryContainer}>
              <table
                className={Styles.summaryTable}
                style={{ tableLayout: "fixed", width: "100%" }}
              >
                <colgroup>
                  <col style={{ width: "5%" }} />
                  <col style={{ width: "15%" }} />
                  <col style={{ width: "22%" }} />
                  <col style={{ width: "10%" }} />
                  <col style={{ width: "10%" }} />
                </colgroup>
                <tbody>
                  <tr>
                    <td className={Styles.summaryCell}>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          gap: 6,
                        }}
                      >
                        <ExpandMoreIcon
                          style={{ fontSize: "18px" }}
                          className={`${Styles.expandIconLeft} ${
                            expanded === index ? Styles.rotateIcon : ""
                          }`}
                        />
                        {index + 1}
                      </div>
                    </td>

                    <td className={Styles.summaryCell}>{ele?.name || "-"}</td>

                    <td
                      className={Styles.summaryViewCell}
                      onClick={(e) => {
                        e.stopPropagation();
                        handleOpenView(ele);
                      }}
                    >
                      View All
                    </td>

                    <td className={Styles.summaryCell}>
                      {Number(ele?.bankingFactor).toFixed(2) ?? "—"}
                    </td>

                    <td className={Styles.summaryCell}>
                      {ele?.settlementRate ?? "—"}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </AccordionSummary>

          <AccordionDetails
            style={{
              backgroundColor: "white",
              borderRadius: "8px",
            }}
          >
            {expanded === index && (
              <>
                {connectionData?.[0]?.counterPartyListings?.length > 0 ? (
                  <ArchiveModal
                    data={connectionData}
                    isLoading={matchmakingLoading}
                    onRefresh={() => {}}
                    onOngoingStatusDetected={() => {}}
                    isWithdrawanView={true}
                  />
                ) : (
                  <div
                    style={{
                      padding: "10px",
                      textAlign: "center",
                      color: "var(--primary-color-text)",
                    }}
                  >
                    No matching records found
                  </div>
                )}
              </>
            )}
          </AccordionDetails>
        </Accordion>
      </div>
      {viewInjectionModalOpen && (
        <ViewInjectionModal
          open={viewInjectionModalOpen}
          handleClose={() => setViewInjectionModalOpen(false)}
          data={selectedInjectionData}
        />
      )}

      {viewDrawalModalOpen && (
        <ViewDrawalModal
          open={viewDrawalModalOpen}
          handleClose={() => setViewDrawalModalOpen(false)}
          data={selectedDrawalData}
        />
      )}

      {viewDetails && (
        <ViewInjectDrawal
          open={viewDetails}
          handleClose={handleCloseView}
          data={selectedListing}
        />
      )}
    </>
  );
};

// const SummaryRowExpired = ({ ele, index, expanded, onToggle }) => {
//   const dispatch = useDispatch();

//   const [viewInjectionModalOpen, setViewInjectionModalOpen] = useState(false);
//   const [selectedInjectionData, setSelectedInjectionData] = useState([]);
//   const [viewDrawalModalOpen, setViewDrawalModalOpen] = useState(false);
//   const [selectedDrawalData, setSelectedDrawalData] = useState([]);

//   const {
//     matchmakingData,
//     loading: matchmakingLoading,
//     activeLedgerData = [],
//   } = useSelector((state) => state.bankingSlice || {});

//   if (!ele) return null;

//   const isPast = ele?.status === "PAST"; // ← key line
//   const inject = ele?.bankingSlotInjects?.[0];
//   const drawal = ele?.bankingSlotDrawls?.[0];

//   const ledgerPage = Array.isArray(activeLedgerData) ? activeLedgerData : [];
//   const connectionData =
//     ledgerPage.length > 0
//       ? ledgerPage
//       : [
//           {
//             selfListing: ele,
//             counterPartyListings: [],
//           },
//         ];

//   const handleAccordionChange = () => {
//     onToggle(index);

//     // Do NOT call APIs for PAST
//     if (expanded !== index && !isPast) {
//       dispatch(
//         fetchMatchmakingResults({
//           id: ele?.id,
//           statusFilter: null,
//         })
//       );

//       dispatch(
//         fetchActiveLedger({
//           currentPage: 0,
//           size: 20,
//           bankingListingId: ele?.id,
//         })
//       );
//     }
//   };

//   const handleViewInjection = (slotData) => {
//     if (!slotData || slotData.length === 0) return;
//     setSelectedInjectionData(slotData);
//     setViewInjectionModalOpen(true);
//   };

//   const handleViewDrawal = (slotData) => {
//     if (!slotData || slotData.length === 0) return;
//     setSelectedDrawalData(slotData);
//     setViewDrawalModalOpen(true);
//   };

//   return (
//     <div className={expanded === index ? "" : Styles.detailsMainDrop_inactive}>
//       <Accordion
//         expanded={expanded === index}
//         onChange={handleAccordionChange}
//         style={{
//           backgroundColor: "#f3f5f8",
//           marginTop: index === 0 ? "0px" : "3px",
//           border:
//             expanded === index ? "1px solid var(--primary-color-text)" : "none",
//           borderRadius: "10px",
//         }}
//       >
//         <AccordionSummary
//           style={{
//             backgroundColor: "white",
//             borderRadius: "8px",
//           }}
//         >
//           <div className={Styles.accordionSummaryContainer}>
//             <table
//               className={Styles.summaryTable}
//               style={{ tableLayout: "fixed", width: "100%" }}
//             >
//               <colgroup>
//                 <col style={{ width: "5%" }} />
//                 <col style={{ width: "15%" }} />
//                 <col style={{ width: "19%" }} />
//                 <col style={{ width: "22%" }} />
//                 <col style={{ width: "10%" }} />
//                 <col style={{ width: "10%" }} />
//               </colgroup>
//               <tbody>
//                 <tr>
//                   <td className={Styles.summaryCell}>
//                     <div
//                       style={{
//                         display: "flex",
//                         alignItems: "center",
//                         justifyContent: "center",
//                         gap: 6,
//                       }}
//                     >
//                       <ExpandMoreIcon
//                         style={{ fontSize: "18px" }}
//                         className={`${Styles.expandIconLeft} ${
//                           expanded === index ? Styles.rotateIcon : ""
//                         }`}
//                       />
//                       {index + 1}
//                     </div>
//                   </td>
//                   <td className={Styles.summaryCell}>{ele?.name || "-"}</td>
//                   <td className={Styles.summaryCell}>
//                     {inject?.dateStartAt || "—"} to {inject?.dateEndAt || "—"}
//                     <span
//                       onClick={(e) => {
//                         e.stopPropagation();
//                         handleViewInjection(ele?.bankingSlotInjects);
//                       }}
//                       style={{ cursor: "pointer" }}
//                     >
//                       <SquareIcon
//                         style={{
//                           width: "10px",
//                           height: "10px",
//                           paddingLeft: 4,
//                         }}
//                       />
//                     </span>
//                   </td>
//                   <td className={Styles.summaryCell}>
//                     {drawal?.dateStartAt || "—"} to {drawal?.dateEndAt || "—"}
//                     <span
//                       onClick={(e) => {
//                         e.stopPropagation();
//                         handleViewDrawal(ele?.bankingSlotDrawls);
//                       }}
//                       style={{ cursor: "pointer" }}
//                     >
//                       <SquareIcon
//                         style={{
//                           width: "10px",
//                           height: "10px",
//                           paddingLeft: 4,
//                         }}
//                       />
//                     </span>
//                   </td>
//                   <td className={Styles.summaryCell}>
//                     {ele?.bankingFactor ?? "—"}
//                   </td>
//                   <td className={Styles.summaryCell}>
//                     {ele?.settlementRate ?? "—"}
//                   </td>
//                 </tr>
//               </tbody>
//             </table>
//           </div>
//         </AccordionSummary>

//         <AccordionDetails
//           style={{
//             backgroundColor: "white",
//             borderRadius: "8px",
//             // padding: "20px",
//           }}
//         >
//           {expanded === index &&
//             (isPast ? (
//               <div
//                 style={{
//                   padding: "10px",
//                   textAlign: "center",
//                   color: "var(--primary-color-text)",
//                   // border: "var(--border-brand-2)",
//                   width: "95%",
//                   margin: "auto",
//                   borderRadius: "8px",
//                 }}
//               >
//                 No matching records
//               </div>
//             ) : (
//               <>
//                 {connectionData && connectionData.length > 0 ? (
//                   <ActiveListingConnection
//                     data={connectionData}
//                     isLoading={matchmakingLoading}
//                     onRefresh={() => {}}
//                     onOngoingStatusDetected={() => {}}
//                   />
//                 ) : (
//                   <div
//                     style={{
//                       padding: "10px",
//                       textAlign: "center",
//                       color: "var(--primary-color-text)",
//                       fontStyle: "italic",
//                     }}
//                   >
//                     No matching records
//                   </div>
//                 )}

//                 {/* {Array.isArray(matchmakingData?.matches) &&
//                 matchmakingData.matches.length > 0 ? (
//                   <div
//                     className={Styles.accordionDetailsContainerUploadDocs}
//                     style={{
//                       margin: "10px 10px 0 10px",
//                       border: expanded === index ? "1px solid #34656D" : "none",
//                     }}
//                   >
//                   </div>
//                 ) : null} */}
//               </>
//             ))}
//         </AccordionDetails>
//       </Accordion>

//       {viewInjectionModalOpen && (
//         <ViewInjectionModal
//           open={viewInjectionModalOpen}
//           handleClose={() => setViewInjectionModalOpen(false)}
//           data={selectedInjectionData}
//         />
//       )}

//       {viewDrawalModalOpen && (
//         <ViewDrawalModal
//           open={viewDrawalModalOpen}
//           handleClose={() => setViewDrawalModalOpen(false)}
//           data={selectedDrawalData}
//         />
//       )}
//     </div>
//   );
// };

const SummaryRowExpired = ({ ele, index, expanded, onToggle }) => {
  const dispatch = useDispatch();
  const [viewInjectionModalOpen, setViewInjectionModalOpen] = useState(false);
  const [selectedInjectionData, setSelectedInjectionData] = useState([]);
  const [viewDrawalModalOpen, setViewDrawalModalOpen] = useState(false);
  const [selectedDrawalData, setSelectedDrawalData] = useState([]);
  const [viewDetails, setViewDetails] = useState(false);
  const [selectedListing, setSelectedListing] = useState(null);
  const [localConnections, setLocalConnections] = useState([]);
  const [isLoadingConnections, setIsLoadingConnections] = useState(false);

  const { archiveConnections = [], loading: matchmakingLoading = false } =
    useSelector((state) => state.bankingSlice || {});

  if (!ele) return null;

  const inject = ele?.bankingSlotInjects?.[0];
  const drawal = ele?.bankingSlotDrawls?.[0];

  const ledgerPage = Array.isArray(localConnections) ? localConnections : [];

  const connectionData =
    ledgerPage.length > 0
      ? ledgerPage.map((connection) => ({
          selfListing: connection.bankingListing || ele,
          counterPartyListings: [
            {
              ...connection.againstBankingListing,
              connectionId: connection.id,
              status: connection.status,
              agreementStatus: connection.agreementStatus,
              connectionInitiatorListingId: connection.bankingListing?.id,
              finalizedConnectionValues: connection.finalizedConnectionValues,
              ledgers: connection.ledgers || [],
              loaDocumentHistory: connection.loaDocumentHistory || [],
              loiDocumentHistory: connection.loiDocumentHistory || [],
              agreementDocumentHistory:
                connection.agreementDocumentHistory || [],
            },
          ],
        }))
      : [
          {
            selfListing: ele,
            counterPartyListings: [],
          },
        ];

  const handleAccordionChange = async () => {
    onToggle(index);

    if (expanded !== index) {
      setIsLoadingConnections(true);
      try {
        const result = await dispatch(
          fetchArchiveConnectionList({
            listingId: ele?.id,
            status: "DELIVERED",
            page: 0,
            size: 20,
          }),
        ).unwrap();

        // Store connections locally for this specific listing
        setLocalConnections(result?.content || []);
      } catch (error) {
        console.error("Error fetching connections:", error);
        setLocalConnections([]);
      } finally {
        setIsLoadingConnections(false);
      }
    } else {
      // Clear local connections when closing accordion
      setLocalConnections([]);
    }
  };

  const handleViewInjection = (slotData) => {
    if (!slotData || slotData.length === 0) return;
    setSelectedInjectionData(slotData);
    setViewInjectionModalOpen(true);
  };

  const handleViewDrawal = (slotData) => {
    if (!slotData || slotData.length === 0) return;
    setSelectedDrawalData(slotData);
    setViewDrawalModalOpen(true);
  };

  const handleCloseView = () => {
    setViewDetails(false);
    setSelectedListing(null);
  };

  const handleOpenView = (listing) => {
    setSelectedListing(listing);
    setViewDetails(true);
  };

  return (
    <div className={expanded === index ? "" : Styles.detailsMainDrop_inactive}>
      <Accordion
        style={{
          backgroundColor: "#f3f5f8",
          marginTop: index === 0 ? "0px" : "3px",
          border:
            expanded === index ? "1px solid var(--primary-color-text)" : "none",
          borderRadius: "10px",
        }}
        expanded={expanded === index}
        onChange={handleAccordionChange}
      >
        <AccordionSummary
          style={{
            backgroundColor: "white",
            borderRadius: "8px",
          }}
        >
          <div className={Styles.accordionSummaryContainer}>
            <table
              className={Styles.summaryTable}
              style={{ tableLayout: "fixed", width: "100%" }}
            >
              <colgroup>
                <col style={{ width: "5%" }} />
                <col style={{ width: "15%" }} />
                <col style={{ width: "19%" }} />
                <col style={{ width: "10%" }} />
                <col style={{ width: "10%" }} />
                <col style={{ width: "12%" }} />
              </colgroup>
              <tbody>
                <tr>
                  <td className={Styles.summaryCell}>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        gap: 6,
                      }}
                    >
                      <ExpandMoreIcon
                        style={{ fontSize: "18px" }}
                        className={`${Styles.expandIconLeft} ${
                          expanded === index ? Styles.rotateIcon : ""
                        }`}
                      />
                      {index + 1}
                    </div>
                  </td>
                  <td className={Styles.summaryCell}>{ele?.name || "-"}</td>
                  <td
                    className={Styles.summaryViewCell}
                    onClick={(e) => {
                      e.stopPropagation();
                      handleOpenView(ele);
                    }}
                  >
                    View All
                  </td>
                  <td className={Styles.summaryCell}>
                    {ele?.bankingFactor
                      ? Number(ele.bankingFactor).toFixed(2)
                      : "—"}
                  </td>
                  <td className={Styles.summaryCell}>
                    {ele?.settlementRate || "—"}
                  </td>
                  <td className={Styles.summaryCell}>{ele?.expiryAt || "—"}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </AccordionSummary>

        <AccordionDetails style={{ backgroundColor: "white" }}>
          {expanded === index && (
            <ArchiveModal
              data={connectionData}
              isLoading={isLoadingConnections || matchmakingLoading}
              onRefresh={() => {}}
              onOngoingStatusDetected={() => {}}
              isExpiredView={true}
            />
          )}
        </AccordionDetails>
      </Accordion>

      {viewInjectionModalOpen && (
        <ViewInjectionModal
          open={viewInjectionModalOpen}
          handleClose={() => setViewInjectionModalOpen(false)}
          data={selectedInjectionData}
        />
      )}

      {viewDrawalModalOpen && (
        <ViewDrawalModal
          open={viewDrawalModalOpen}
          handleClose={() => setViewDrawalModalOpen(false)}
          data={selectedDrawalData}
        />
      )}
      {viewDetails && (
        <ViewInjectDrawal
          open={viewDetails}
          handleClose={handleCloseView}
          data={selectedListing}
        />
      )}
    </div>
  );
};
const BankingArchive = ({ type, status }) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const statusFromQuery = searchParams.get("status") || status;

  const {
    archiveList = [],
    loading = false,
    totalPages = 0,
  } = useSelector((state) => state.bankingSlice || {});

  const [expanded, setExpanded] = useState(-1);
  const [page, setPage] = useState(0);
  const [size] = useState(10);
  const [accumulatedData, setAccumulatedData] = useState([]);

  // Calculate if there are more pages to load
  const hasMore = page + 1 < totalPages;

  // Reset to initial state when status changes
  useEffect(() => {
    setPage(0);
    setExpanded(-1);
    setAccumulatedData([]);
  }, [statusFromQuery]);

  useEffect(() => {
    setExpanded(-1);
  }, [type, status]);

  // Append new data when archiveList updates
  useEffect(() => {
    if (archiveList && archiveList.length > 0) {
      if (page === 0) {
        // First page: replace data
        setAccumulatedData(archiveList);
      } else {
        // Subsequent pages: append data
        setAccumulatedData((prev) => [...prev, ...archiveList]);
      }
    } else if (page === 0) {
      // If first page has no data, clear accumulated data
      setAccumulatedData([]);
    }
  }, [archiveList, page]);

  const handleAccordionChange = useCallback(
    (val) => {
      setExpanded((prev) => (prev === val ? -1 : Number(val)));
    },
    [setExpanded],
  );

  const handleLoadMore = useCallback(() => {
    if (!loading && hasMore) {
      setPage((prev) => prev + 1);
    }
  }, [loading, hasMore]);

  useEffect(() => {
    if (statusFromQuery) {
      const apiStatus =
        statusFromQuery === "Closed" ? "PAST" : statusFromQuery.toUpperCase();
      dispatch(
        fetchBankingArchive({ status: apiStatus, currentPage: page, size }),
      );
    }
  }, [dispatch, statusFromQuery, page, size]);

  return (
    <LoadMorePagination
      hasMore={hasMore && !loading}
      onLoadMore={handleLoadMore}
      loading={loading && page > 0}
    >
      <div
        style={{
          height: "calc(100vh - 280px)",
          overflowY: "auto",
          overflowX: "hidden",
        }}
      >
        <LoaderNoData
          loading={loading && page === 0 && accumulatedData.length === 0}
          dataLength={accumulatedData?.length ?? 0}
        />

        {!(loading && page === 0 && accumulatedData.length === 0) && (
          <>
            {statusFromQuery === "Closed" ? (
              <>
                {accumulatedData?.length > 0 && <SummaryHeader />}
                {accumulatedData?.map((ele, index) => (
                  <SummaryRow
                    key={ele?.id ?? ele?.name ?? index}
                    ele={ele}
                    index={index}
                    expanded={expanded}
                    onToggle={handleAccordionChange}
                  />
                ))}
              </>
            ) : statusFromQuery === "Withdrawn" ? (
              <>
                {accumulatedData?.length > 0 && <SummaryHeaderWithdrawn />}
                {accumulatedData?.map((ele, index) => (
                  <SummaryRowWithdrawn
                    key={ele?.id ?? ele?.name ?? index}
                    ele={ele}
                    index={index}
                    expanded={expanded}
                    onToggle={handleAccordionChange}
                  />
                ))}
              </>
            ) : statusFromQuery === "Expired" ? (
              <>
                {statusFromQuery === "Expired" &&
                  accumulatedData?.length > 0 && <SummaryHeaderExpired />}
                {accumulatedData?.map((ele, index) => (
                  <SummaryRowExpired
                    key={ele?.id ?? ele?.name ?? index}
                    ele={ele}
                    index={index}
                    expanded={expanded}
                    onToggle={handleAccordionChange}
                  />
                ))}
              </>
            ) : null}
          </>
        )}
      </div>
    </LoadMorePagination>
  );
};

export default BankingArchive;
